import axios, { AxiosPromise } from 'axios';
import {
  ICertificateAmountParams,
  IEventOrderInfoReq,
  IGetCertificateAmounts,
  IGetEventOrderInfo,
  IGetOrderInfo,
  IGetPaymentCharges,
  IGetPaymentDetail,
  IGetPaymentOverallSales, IGetPaymentReceipt,
  IGetPaymentRecords,
  IGetRecentTuition,
  IGetSalesStats,
  IGetStudentBreakdownDetails,
  IGetStudentBreakdowns,
  IGetStudentPayments,
  IGetStudentPaymentsDetails,
  IPaymentChargeParams,
  IPaymentItemReq,
  IPaymentOverallSalesParams,
  IPaymentRecordParams,
  IPostStudentPaymentTodo,
  IPostTossPaymentTodo,
  ISalesStatsParams,
  ISalesStatsPeriodParams,
  IShuttleAmountReq,
  IUpdatePaymentLastBody,
} from '../models/payments.model';
import QueryString from 'qs';
import { handleEmptyString } from '../lib/util';

const uri = '/mgmt/payments';
const serviceUri = '/service/payments';

export const createTossPaymentTodo = (
  body: any,
): AxiosPromise<IPostTossPaymentTodo> => {
  return axios.put(`${serviceUri}/tran-order-todo`, body);
};

export const updatePaymentTodo = (
  body: IUpdatePaymentLastBody,
): AxiosPromise<IGetOrderInfo> => {
  return axios.post(`${serviceUri}/order-id`, body);
};

export const getStudentBreakdownsTodo = (
  memberCode: string,
): AxiosPromise<IGetStudentBreakdowns> => {
  return axios.get(`${serviceUri}/${memberCode}/todo`);
};

export const getStudentBreakdownDetailsTodo = (
  paymentRecordCode: number,
): AxiosPromise<IGetStudentBreakdownDetails> => {
  return axios.get(`${serviceUri}/${paymentRecordCode}/detail/todo`);
};

export const getStudentPaymentsDetailsTodo = (paymentRecordCode: number): AxiosPromise<IGetStudentPaymentsDetails> => {
  return axios.get(`${uri}/${paymentRecordCode}/student/detail`);
};

export const updateShuttleAmount = (data: IShuttleAmountReq): AxiosPromise => {
  return axios.put(`${serviceUri}/shuttle-amount`, data);
};

export const deleteShuttleAmount = (paymentNo: number): AxiosPromise => {
  return axios.delete(`${serviceUri}/shuttle-amount/${paymentNo}`);
};

export const createTempPaymentTodo = (
  memberCode: string,
  paymentRecordCode: number,
  data: { installment: number },
): AxiosPromise<IPostStudentPaymentTodo> => {
  return axios.post(
    `${serviceUri}/temp-list/${memberCode}/${paymentRecordCode}/todo`,
    data,
  );
};

export const replacePaymentTodo = (
  orgPaymentRecordCode: number,
  newPaymentRecordCode: number,
): AxiosPromise => {
  return axios.put(
    `${serviceUri}/temp-change/${orgPaymentRecordCode}/${newPaymentRecordCode}/todo`,
  );
};

export const updatePaymentByCoupon = (
  paymentRecordCode: number,
): AxiosPromise => {
  return axios.put(`${serviceUri}/coupon-delete/${paymentRecordCode}`);
};

export const createPaymentItem = (data: IPaymentItemReq[]): AxiosPromise => {
  return axios.post(uri, data);
};

export const getSalesStats = (
  params: ISalesStatsParams,
): AxiosPromise<IGetSalesStats> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/tuition?${qsParams}`);
};

export const getSalesPeriodStats = (
  params: ISalesStatsPeriodParams,
): AxiosPromise<IGetSalesStats> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/sales?${qsParams}`);
};

export const getPaymentRecords = (
  params: IPaymentRecordParams,
): AxiosPromise<IGetPaymentRecords> => {
  const qsParams = QueryString.stringify(handleEmptyString(params));
  return axios.get(`${uri}/pay-list?${qsParams}`);
};

export const getCertificateAmounts = (
  params: ICertificateAmountParams,
): AxiosPromise<IGetCertificateAmounts> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/certificate?${qsParams}`);
};

export const getEventOrderInfo = (
  data: IEventOrderInfoReq,
): AxiosPromise<IGetEventOrderInfo> => {
  return axios.post(`${uri}/event-order-id`, data);
};

// legacy

export const getStudentPayments = (
  memberCode: string,
  paymentRecordCode = -1,
): AxiosPromise<IGetStudentPayments> => {
  return axios.get(`${uri}/${memberCode}/${paymentRecordCode}/list`);
};

export const getStudentBreakdowns = (
  memberCode: string,
): AxiosPromise<IGetStudentBreakdowns> => {
  return axios.get(`${uri}/${memberCode}`);
};

export const getStudentBreakdownDetails = (
  paymentRecordCode: number,
): AxiosPromise<IGetStudentBreakdownDetails> => {
  return axios.get(`${uri}/${paymentRecordCode}/detail`);
};

export const getPaymentDetail = (
  paymentRecordCode: number,
): AxiosPromise<IGetPaymentDetail> => {
  return axios.get(`${uri}/detail/${paymentRecordCode}`);
};

export const getPaymentCharges = (
  params: IPaymentChargeParams,
): AxiosPromise<IGetPaymentCharges> => {
  return axios.get(`${uri}/payment-target`, { params });
};

export const getRecentTuition = (
  campusDiv: string,
): AxiosPromise<IGetRecentTuition> =>
  axios.get(`${uri}/recent-tuition?campusDiv=${campusDiv}`);

export const getPaymentOverallSales = (
  params?: IPaymentOverallSalesParams,
): AxiosPromise<IGetPaymentOverallSales> =>
  axios.get(`${uri}/overall-sales`, { params });

export const getPaymentReceipt = (
  orderId: number,
): AxiosPromise<IGetPaymentReceipt> => {
  return axios.get(`${uri}/${orderId}/receipt`);
};
